var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"border":"2px solid #e2e2e5","background-color":"white"},attrs:{"small":"","icon":"","disabled":_vm.disabled,"color":"#aaa"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }